import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { HorizontalDivider } from '../../HorizontalDivider/HorizontalDivider';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { NavigationHorizontalItem } from './NavigationHorizontalItem';
const StyledNavigationHorizontal = styled('div', ({ $backgroundColor }) => ({
    backgroundColor: $backgroundColor,
    display: 'flex',
    flexGrow: 1,
}));
export const NavigationHorizontal = ({ items, testId, ItemWrapper, backgroundColor = 'grey', hasDivider, rightElement, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const navigationBackgroundColorMap = {
        grey: staticColors.navBarHorizontalGreyBackground,
        white: staticColors.navBarHorizontalWhiteBackground,
    };
    return (_jsxs(FlexContainer, { direction: 'column', ...testIdAttribute, children: [_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'top', children: [_jsx(StyledNavigationHorizontal, { $backgroundColor: navigationBackgroundColorMap[backgroundColor], children: _jsx(FlexContainer, { direction: 'row', horizontalAlign: 'left', verticalAlign: 'center', grow: 1, gap: true, children: items.map((item, index) => {
                                const renderContent = ({ isActive, }) => (_jsx(NavigationHorizontalItem, { isActive: isActive, ...item }));
                                return (_jsx(Box, { children: _jsx(ItemWrapper, { index: index, item: item, renderContent: renderContent }) }, index));
                            }) }) }), rightElement] }), hasDivider && _jsx(HorizontalDivider, {})] }));
};
